import { createRegistrationPaymentOrder, getRegistrationPaymentStatus } from './backend';
import { safeExternalUrl } from '../../utils/safeNavigation';

export async function startRegistrationPayment({ packageId }) {
  const order = await createRegistrationPaymentOrder({ packageId, origin: window.location.origin });
  if (order?.alreadyPaid || order?.activated || order?.provider === 'free' || order?.required === false) {
    return { ...order, provider: order?.provider || 'free', activated: true };
  }
  if (!['stripe', 'revolut'].includes(order?.provider)) throw new Error('The configured payment provider is unavailable.');
  if (!order.checkoutUrl) throw new Error('The payment page could not be created. Please try again.');
  const checkoutUrl = safeExternalUrl(order.checkoutUrl, { allowBlob: false });
  if (!checkoutUrl) throw new Error('The payment provider returned an unsafe checkout URL.');
  window.location.assign(checkoutUrl);
  return { provider: order.provider, redirected: true, sessionId: order.sessionId, orderId: order.orderId };
}

export { getRegistrationPaymentStatus };
export default { startRegistrationPayment, getRegistrationPaymentStatus };
